import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AllVehicles.css";
import HomeBanner from "../Components/HomeBanner";
//import "./Navbar.css";
import { NavLink } from "react-router-dom";
import SearchCarsSection from "../Components/SearchCarsSection";

const AllVehicles = () => {
  const [country, setCountry] = useState("Loading...");
  const [cars, setCars] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const totalPages = Math.ceil(cars.length / itemsPerPage);
  const indexOfLastCar = currentPage * itemsPerPage;
  const indexOfFirstCar = indexOfLastCar - itemsPerPage;
  const currentCars = cars.slice(indexOfFirstCar, indexOfLastCar);

  /* Fetch country */
  useEffect(() => {
    fetch("https://api.mitradingjp.com/get-country.php")
      .then((res) => res.json())
      .then((data) => setCountry(data.country))
      .catch(() => setCountry("Unknown"));
  }, []);

  /* Fetch all vehicles */
 useEffect(() => {
     // Fetch car details
     fetch('https://api.mitradingjp.com/get-car-details.php')
     //fetch('https://api.mitradingjp.com/fetch_cars.php')
       .then(response => {
         if (!response.ok) {
           throw new Error(`HTTP error! Status: ${response.status}`);
         }
         return response.json();
       })
       .then(data => {
            setCars(data);
            setCurrentPage(1);
        })
       .catch(error => {
         console.error("Error fetching car details:", error);
       });
   }, []);

   
  return (
    <>
      <div className="container-fluid">
        <HomeBanner />
        <SearchCarsSection />
      </div>

      <div className="container-fluid my-5">
        <div className="carousel-bg mb-5">
          <div className="main-title">
            <h2>All Vehicles</h2>
          </div>
        </div>

        <div className="row g-3">
            {currentCars.map((car) => (
                <div className="row my-1" key={car.id}>
                    <div className="col-md-4 col-sm-6">
                        <a href={`/vehicle-details/${car.id}`}>
                        <div className="car-card position-relative">
                            <img
                            src={`https://api.mitradingjp.com/${car.images}`}
                            alt={car.model}
                            className="img-fluid"
                            />
                        </div>
                        </a>
                    </div>
                {/* Details */}
                <div className="col-md-8 col-sm-6">
                    <div className="car-details">
                      <div className="vehicle-header">
                        <h3 className="mb-1 text-center">
                            <a href={`/vehicle-details/${car.id}`} title={car.model}>
                            {car.year} - {car.maker} {car.model}
                            </a>
                        </h3>
                         <small><p className="small text-muted mb-0">Stock Number: {car.stock_id}</p></small>
                      </div>
                      <table className="table table-bordered table-sm">
                          <tbody>
                          <tr>
                              <td><strong>Mileage</strong></td>
                              <td>{car.mileage} km</td>
                              <td><strong>Engine</strong></td>
                              <td>{car.engine} cc</td>
                              <td><strong>Steering</strong></td>
                              <td>{car.steering}</td>
                          </tr>
                          <tr>
                              <td><strong>Color:</strong></td>
                              <td>{car.color} km</td>
                              <td><strong>Doors:</strong></td>
                              <td>{car.doors}</td>
                              <td><strong>Seats:</strong></td>
                              <td>{car.seats}</td>
                          </tr>
                          <tr>
                              <td><strong>Transmission</strong></td>
                              <td>{car.transmission}</td>
                              <td><strong>Drive</strong></td>
                              <td>{car.drive}</td>
                              <td><strong>Fuel</strong></td>
                              <td>{car.fuel}</td>
                          </tr>
                          </tbody>
                      </table>
                      <div className="topbars">
                        <span><NavLink to="#">VEHICLE PRICE</NavLink></span>
                        <span><NavLink to="#">CNF PRICE</NavLink></span>
                        <span><NavLink to="#">GET QUOTE</NavLink></span>
                        <span><NavLink to="#">VIEW VEHICLE</NavLink></span>
                      </div>
                    </div>
                </div>
                <hr /> 
            </div>
          ))}


          {cars.length === 0 && (
            <div className="text-center">Loading vehicles ....</div>
          )}
          
        </div>

        {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
                <nav>
                <ul className="pagination">

                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    >
                        Previous
                    </button>
                    </li>

                    {[...Array(totalPages)].map((_, i) => (
                    <li
                        key={i}
                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                    >
                        <button
                        className="page-link"
                        onClick={() => setCurrentPage(i + 1)}
                        >
                        {i + 1}
                        </button>
                    </li>
                    ))}

                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                        className="page-link"
                        onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                    >
                        Next
                    </button>
                    </li>

                </ul>
                </nav>
            </div>
            )}
      <hr /> 
      </div>
    </>
  );
};

export default AllVehicles;
